import { createContext, useContext } from 'react'

import { isNil } from 'lodash-es'

import { LocationSearchResult } from '@forto-dev/locations-models'

import { AddressFormData } from '../schema'

export type AddressSelectorDispatchContextState = {
  onAddressSearchChange: (selectedAddress: LocationSearchResult | null) => void
  onAddManualAddress: () => void
  onSearchAddressResultSelected: (selectedAddress: AddressFormData | null) => void
  onManualAddressSelected: (selectedAddress: AddressFormData | null) => void
}

export const AddressSelectorDispatchContext = createContext<AddressSelectorDispatchContextState | null>(null)

export const useAddressSelectorDispatchContext = (): AddressSelectorDispatchContextState => {
  const ctx = useContext(AddressSelectorDispatchContext)

  if (isNil(ctx)) {
    throw new Error('useAddressSelectorDispatchContext must be used within a AddressSelectorDispatchContext.Provider')
  }

  return ctx
}
